import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { CoveoAnalyticsDirective } from './coveo-user-analytics.directive';
export var CoveoAnalyticsComponentNgModule = module(baseModuleId + ".coveo-user-analytics", [])
    .directive('coveoAnalytics', CoveoAnalyticsDirective);
